import { Building, Hammer, PaintBucket, Ruler, Shield, Wrench } from 'lucide-react';
import { useState, useEffect } from 'react';
import SEO from '@/components/SEO';

const Services = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch('/api/services-content-public');
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Yükleniyor...</div>
      </div>
    );
  }

  if (!content) return null;

  const serviceIcons = [Building, Hammer, Wrench, Ruler, Shield, PaintBucket];

  return (
    <>
    <SEO 
      title="Hizmetlerimiz"
      description="MİGA Yapı hizmetleri: Kentsel dönüşüm, yeni inşaat, tadilat & renovasyon, proje tasarım, güçlendirme ve iç-dış mekan düzenleme. İstanbul ve Kocaeli'de profesyonel inşaat hizmetleri."
      keywords="kentsel dönüşüm hizmeti, inşaat hizmetleri, tadilat, renovasyon, güçlendirme, proje tasarım, istanbul inşaat"
    />
    <div data-testid="services-page" className="min-h-screen pt-24 pb-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1
            data-testid="services-title"
            className="heading-font text-5xl sm:text-6xl font-bold text-[#1e4a7a] mb-6"
          >
            {content.title}
          </h1>
          <div className="w-24 h-1 bg-[#dc2626] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.services.map((service, index) => {
            const Icon = serviceIcons[index] || Building;
            return (
              <div
                key={index}
                data-testid={`service-card-${index}`}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#1e4a7a] to-[#2563eb] rounded-2xl flex items-center justify-center mb-6">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="heading-font text-2xl font-semibold text-[#1e4a7a] mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <div className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-500">
                      <div className="w-1.5 h-1.5 bg-[#dc2626] rounded-full mr-2"></div>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Process Section */}
        <div className="mt-20 bg-white rounded-3xl p-8 sm:p-12 shadow-lg">
          <h2 className="heading-font text-4xl font-bold text-[#1e4a7a] text-center mb-12">
            Çalışma Sürecimiz
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { step: '01', title: content.process_step1_title, desc: content.process_step1_desc },
              { step: '02', title: content.process_step2_title, desc: content.process_step2_desc },
              { step: '03', title: content.process_step3_title, desc: content.process_step3_desc },
              { step: '04', title: content.process_step4_title, desc: content.process_step4_desc },
            ].map((item, index) => (
              <div key={index} data-testid={`process-step-${index}`} className="text-center">
                <div className="heading-font text-5xl font-bold text-[#dc2626]/20 mb-4">{item.step}</div>
                <h3 className="heading-font text-xl font-semibold text-[#1e4a7a] mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Services;